import React, { useContext, useEffect, useState } from "react";
import androidImg from "../assets/android.png";
import iosImg from "../assets/ios.png";
import macImg from "../assets/mac.png";
import windowsImg from "../assets/windows.png";
import field from "../assets/Field.png";
import mobiledownload from "../assets/mobiledownload.png";
import pipeline from "../assets/pipeline.png";
import paddy from "../assets/Paddy.png";
import { FaDownload } from "react-icons/fa";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import { HomeNavigator } from "../util/HomeNavigator";
import { ActiveContext } from "../App";
function Download() {
  const [platform, setPlatform] = useState("Android");
  const [active, setActive] = useContext(ActiveContext);
  const platforms = [
    { name: "Android", icon: androidImg },
    { name: "IOS", icon: iosImg },
    { name: "macOS", icon: macImg },
    { name: "Windows", icon: windowsImg },
  ];

  const activeIcon = platforms.find((p) => p.name === platform)?.icon || null;
  useEffect(() => {
    if (localStorage.getItem("idScroll") !== null) {
      document
        .getElementById(
          localStorage.getItem("idScroll")
            ? localStorage.getItem("idScroll")
            : "",
        )
        .scrollIntoView({ behavior: "instant" });
    }
    localStorage.removeItem("idScroll");
  }, []);
  return (
    <div className=" w-full min-h-screen ">
      {localStorage.getItem("productBack") === "home" && (
        <HomeNavigator id="downloads" />
      )}{" "}
      <div className="w-full h-fit flex flex-col gap-5 mobile:px-1 mobile:py-5 p-10 tracking-wider text-gray-500 bg-gradient-to-b from-lime-200 to-white overflow-x-hidden">
        {/* Buttons */}
        <div className="w-full flex flex-row mobile:gap-1 gap-5 items-center justify-center">
          {platforms.map((item) => (
            <button
              key={item.name}
              onClick={() => setPlatform(item.name)}
              className={`flex items-center gap-2 w-fit mobile:px-2 mobile:py-1 mobile:text-[10px] px-5 py-3 rounded-3xl text-sm font-semibold transition
            ${
              platform === item.name
                ? "bg-lime-800 text-white"
                : "bg-lime-50 hover:scale-[1.05] hover:outline hover:outline-1 hover:outline-offset-[-1px] hover:text-white hover:bg-gradient-to-b from-lime-800 to-lime-500 outline outline-1 outline-lime-400 text-lime-800"
            }`}
            >
              {item.name}
            </button>
          ))}
        </div>

        {/* Dynamic Content */}
        <div className=" text-center flex flex-col items-center">
          <h2 className="text-neutral-800 ipadMin:text-2xl mobile:text-[14px] text-4xl font-bold flex mobile:flex-wrap items-center mobile:gap-1 gap-2">
            {activeIcon && (
              <img
                src={activeIcon}
                alt={platform}
                className="w-8 h-8  mobile:h-5 mobile:w-5 object-contain"
              />
            )}
            AI Field Controller for {platform}
          </h2>

          <p className="mt-3 mobile:mt-1 text-neutral-600 mobile:text-[16px] text-2xl">
            Click below to download
          </p>

          <button className="mt-3 hover:bg-gradient-to-b from-lime-800 to-lime-500 flex text-lg mobile:text-[14px] items-center gap-2 px-6 py-3 bg-lime-800 text-white rounded-xl shadow-md hover:bg-lime-900 transition">
            <FaDownload />
            Download for {platform}
          </button>

          <p className="mt-3 text-neutral-600 mobile:text-sm ">
            For {platform} 16 and later
          </p>
        </div>
        <div className="w-full flex flex-row gap-2 mobile:flex-col ipadMin:grid ipadMin:grid-cols-2  items-center justify-center">
          <img
            src={pipeline}
            alt="pipeline"
            className="w-[250px] mobile:w-full ipadMin:w-full  h-[200px] rounded-lg object-contain"
          />

          <img
            src={mobiledownload}
            alt="mobiledownload"
            className="w-[250px] h-[200px] mobile:w-full ipadMin:w-full rounded-lg object-contain"
          />
          <img
            src={field}
            alt="field"
            className="w-[250px] h-[200px] mobile:w-full ipadMin:w-full rounded-lg object-contain"
          />
        </div>
        <div className=" left-[-50px]     flex flex-col gap-1 justify-center items-center">
          <img
            className="w-50 ipadMax:w-32 ipadMin:w-32 mobile:w-32 absolute h-32 object-contain left-0 "
            src={paddy}
          />
        </div>
      </div>
      <div className="w-full  h-fit p-10 ipadMin:p-5 mobile:p-4 flex flex-col  items-center justify-center bg-gradient-to-t from-lime-200 to-white">
        <div className="w-full  h-fit flex flex-row  items-center justify-between ">
          <div className="w-fit flex flex-col items-center justify-start ">
            <img
              className="w-[140px] h-[100px]  object-contain"
              src={require("../assets/downloadcompanylogo.png")}
              alt=""
              srcSet=""
            />
            <div className="flex flex-row mobile:hidden gap-3 ">
              <p className="text-center justify-start text-lime-950 text-lg  ipadMin:text-[12px] mobile:text-[10px]  ">
                Follow us on
              </p>
              <div className="flex flex-row gap-2">
                <a
                  target="_blank"
                  href="http://www.youtube.com/@THEJATECHNOLOGIES"
                  className="hover:scale-[1.05] text-lime-950 cursor-pointer"
                >
                  <YouTubeIcon className="w-6 h-6 mobile:w-1 mobile:h-1" />
                </a>

                <a
                  target="_blank"
                  href="https://in.linkedin.com/company/theja-technologies-private-limited"
                  className="hover:scale-[1.05] text-lime-950 cursor-pointer"
                >
                  <LinkedInIcon className="w-6 h-6 mobile:w-1 mobile:h-1" />
                </a>

                <a
                  target="_blank"
                  href="https://twitter.com/Thejatech"
                  className="hover:scale-[1.05] text-lime-950 cursor-pointer"
                >
                  <TwitterIcon className="w-6 h-6 mobile:w-1 mobile:h-1" />
                </a>

                <a
                  target="_blank"
                  href="https://www.instagram.com/theja_tech/"
                  className="hover:scale-[1.05] text-lime-950 cursor-pointer"
                >
                  <InstagramIcon className="w-6 h-6 mobile:w-1 mobile:h-1" />
                </a>
              </div>
            </div>
          </div>
          <div className="w-fit flex flex-col items-center justify-center ">
            <img
              className="w-[140px] mobile:w-[60px] object-contain  mobile:h-[80px] h-[100px]"
              src={require("../assets/plant.png")}
              alt=""
              srcSet=""
            />
            <div className="flex mobile:hidden gap-2 items-center ">
              <p className="text-center justify-start  text-neutral-700 text-lg ipadMin:text-[12px] mobile:text-[10px] ">
                Privacy Terms © 2026 All Rights Reserved
              </p>
            </div>
          </div>
        </div>
        <div className="w-full flex-row gap-2 items-center justify-center flex flex-wrap">
          <div className="w-fit  hidden mobile:flex flex-row justify-center items-center mobile:gap-2 gap-2">
            <p className="text-center text-lime-950 text-lg ipadMin:text-[14px] mobile:text-[12px]">
              Follow us on
            </p>

            <div className="flex flex-row gap-2">
              <a
                target="_blank"
                href="http://www.youtube.com/@THEJATECHNOLOGIES"
                className="hover:scale-[1.05] text-lime-950 cursor-pointer"
              >
                <YouTubeIcon className="w-6 h-6 mobile:w-4 mobile:h-4" />
              </a>

              <a
                target="_blank"
                href="https://in.linkedin.com/company/theja-technologies-private-limited"
                className="hover:scale-[1.05] text-lime-950 cursor-pointer"
              >
                <LinkedInIcon className="w-6 h-6 mobile:w-4 mobile:h-4" />
              </a>

              <a
                target="_blank"
                href="https://twitter.com/Thejatech"
                className="hover:scale-[1.05] text-lime-950 cursor-pointer"
              >
                <TwitterIcon className="w-6 h-6 mobile:w-4 mobile:h-4" />
              </a>

              <a
                target="_blank"
                href="https://www.instagram.com/theja_tech/"
                className="hover:scale-[1.05] text-lime-950 cursor-pointer"
              >
                <InstagramIcon className="w-6 h-6 mobile:w-4 mobile:h-4" />
              </a>
            </div>
          </div>
          <div className="flex mobile:block hidden gap-2 items-center ">
            <p className="text-center justify-start  text-neutral-700 text-lg ipadMin:text-[12px] mobile:text-[12px] ">
              Privacy Terms © 2026 All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Download;
